import { HttpClient, HttpXhrBackend } from '@angular/common/http';
import { map, Observable, of, ReplaySubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@services/app-config.service';
import { catchError } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class AvailabilityMonitor {
	public appAvailability$: Observable<'online' | 'offline'>;
	private _client = new HttpClient(new HttpXhrBackend({
		build: () => new XMLHttpRequest()
	}));
	private internalStatus: 'online' | 'offline' = 'online';

	private appAvailabilitySource: ReplaySubject<'online' | 'offline'> = new ReplaySubject<'online' | 'offline'>(1);

	constructor(private appConfig: AppConfigService) {
		this.appAvailability$ = this.appAvailabilitySource.asObservable();
	}

	public start$(): Observable<any> {
		if(this.appConfig.getConfig().environment === 'development') {
			this.appAvailabilitySource.next("online");
			return of(null);
		}
		setInterval(() => {
			this.verifyApplicationIsOnline().subscribe();
		}, 60000);
		return this.verifyApplicationIsOnline();
	}

	private verifyApplicationIsOnline() {
		return this._client.get<{ status: 'online' | 'offline' }>('/status.json').pipe(
			map((x) => {
				this.internalStatus = x?.status || 'online';
				this.appAvailabilitySource.next(this.internalStatus);

				if (this.internalStatus === "offline" && window.location.pathname !== '/status') {
					window.location.href = '/status';
				}

			}),
			catchError(() => {
				if (this.internalStatus !== 'offline') {
					this.appAvailabilitySource.next('online');
				}

				return of(null);
			})
		);
	}

}
